var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
export default function Button(props) {
    const [loading, setLoading] = React.useState(false);
    const executeAction = (event) => __awaiter(this, void 0, void 0, function* () {
        if (!props.disabled && !loading) {
            !props.disableLoader && setLoading(true);
            try {
                yield props.onClick(event);
            }
            catch (e) {
                !props.disableLoader && setLoading(false);
                throw e;
            }
            setLoading(false);
        }
    });
    return (React.createElement("div", { className: `cursor-pointer font-semibold tracking-wider font-sans ${props.outline
            ? 'bg-transparent text-navy-blue-500 border-navy-blue-500 border-2'
            : 'bg-navy-blue-500 text-white'} w-full text-center text-lg py-3 ${props.noMargin ? '' : 'mb-4'} rounded transition-opacity hover:opacity-75 focus:border-black ${props.disabled ? 'bg-light-gray border-muted' : ''}`, onClick: executeAction }, loading ? (React.createElement("i", { className: "vp-icon-spinner-solid animate-spin" })) : (props.children)));
}
